function getInventoryAvailable(variants, id) {
  let qty = 0;

  if (variants && variants.length) {
    variants.forEach(inv => {
      if (inv.id == id) {
        qty = inv.quantity;
      }
    });
  }

  return qty;
}

function initCustomizeItButton() {
  const custlink = document.querySelector(".customizeit");
  if (!custlink) return;

  let variants = [];
  try {
    variants = JSON.parse(custlink.dataset.variants || '[]');
  } catch (e) {
    console.error('Failed to parse variants data:', e);
  }

  function usePushState(handler) {
    // Modern themes use pushstate to track variant changes without reload
    function track(fn, handler, before) {
      return function interceptor() {
        if (before) {
          handler.apply(this, arguments);
          return fn.apply(this, arguments);
        } else {
          const result = fn.apply(this, arguments);
          handler.apply(this, arguments);
          return result;
        }
      };
    }

    let currentVariantId = null;
    function variantHandler() {
      const priceEl = document.querySelector("#main-product-content .f8pr-price span");
      if (priceEl && !priceEl.innerHTML.startsWith("As low as")) {
        priceEl.innerHTML = "As low as " + priceEl.innerHTML;
      }

      const selectedVariantId = window.location.search.replace(/.*variant=(\d+).*/, '$1');
      if (!selectedVariantId) return;

      if (selectedVariantId != currentVariantId) {
        currentVariantId = selectedVariantId;
        handler(selectedVariantId);
      }
    }

    // Assign listeners
    window.history.pushState = track(history.pushState, variantHandler);
    window.history.replaceState = track(history.replaceState, variantHandler);
    window.addEventListener('popstate', variantHandler);
  }

  usePushState(function(variantId) {
    const vurl = new URL(custlink.href);
    const paths = vurl.pathname.split("/");
    const qty = getInventoryAvailable(variants, variantId);

    paths[paths.length - 1] = variantId;
    vurl.pathname = paths.join("/");

    if (qty <= 0) {
      custlink.classList.add('outofstock');
      custlink.innerText = "Out of Stock";
    } else {
      custlink.href = vurl.toString();
      custlink.innerText = "Customize It";
      custlink.classList.remove('outofstock');
    }
  });

  // Initial price update
  const priceEl = document.querySelector("#main-product-content .f8pr-price span");
  if (priceEl && !priceEl.innerHTML.startsWith("As low as")) {
    priceEl.innerHTML = "As low as " + priceEl.innerHTML;
  }
}

document.addEventListener('DOMContentLoaded', initCustomizeItButton);
